import { put, call, takeLatest } from "@redux-saga/core/effects";
import { messageListApi } from "../Api/api";
import { messageslistFail, messageslistLoad, messageslistSuccess } from "../slices/message.slice";

function* messageslistSaga(action) {
    try {
        const data = yield call(messageListApi, action.payload);
        if (data.status === 0) {
            yield put(messageslistSuccess(data.result.data));
        } else {
            yield put(messageslistFail());
        }
    } catch (e) {
        console.error("Inner circle saga error:", e);
        yield put(messageslistFail());
    }
}


export default function* rootMessagesSaga() {
    yield takeLatest(messageslistLoad.type, messageslistSaga);

}
